import api from './api';
import { bool } from 'yup';
import Axios from 'axios';
import { getJwt } from '@app/helpers';


export interface formularoReprovacaoAprovacao {
    medicaoId: string
    nivel: number;
}


export const realizarAprovacaoNivel = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarAprovacaoNivel`, form);
export const realizarReprovacaoNivel = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarReprovacaoNivel`, form);


export const realizarAprovacaoNivel1 = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarAprovacaoNivel1`, form);
export const realizarAprovacaoNivel2 = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarAprovacaoNivel2`, form);
export const realizarAprovacaoNivel3 = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarAprovacaoNivel3`, form);


export const realizarReprovacaoNivel1 = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarReprovacaoNivel1`, form);
export const realizarReprovacaoNivel2 = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarReprovacaoNivel2`, form);
export const realizarReprovacaoNivel3 = (form: formularoReprovacaoAprovacao) => api.put(`Medicao/realizarReprovacaoNivel3`, form);